import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { MemeDashboardStatusService } from '@src/app/modules/meme-dashboard/meme-dashboard-status.service';
import { CommonModule } from '@angular/common';
import { CommonService } from '@src/app/services/common.service';
import { UserService } from '@src/app/services/user.service';

@Component({
    selector: 'app-profile-settings-dropdown',
    templateUrl: './profile-settings-dropdown.component.html',
    styleUrls: ['./profile-settings-dropdown.component.less'],
    standalone: true,
    imports: [CommonModule, SharedModule],
})
export class ProfileSettingsDropdownComponent {
    get subscribedWatchlistCount() {
        return this.memeDashboardStatusService.mySubscribedWatchlistAgents$.getValue()?.length ?? 0;
    }

    get socialMediaVisible() {
        return !this.walletStatusService.userProfile?.telegram_id || !this.walletStatusService.userProfile?.twitter_id;
    }

    constructor(
        public walletStatusService: WalletStatusService,
        private memeDashboardStatusService: MemeDashboardStatusService,
        private userService: UserService,
        private commonService: CommonService
    ) {}

    showSettingsModal() {
        this.memeDashboardStatusService.showGeneralSettings();
    }

    toggleWalletConnection() {
        this.userService.logout();
    }
}
